var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 379,
    height: 296,
    viewBox: "0 0 379 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_624_1167",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 378,
    height: 284
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4664 20.6929C4.55916 14.8845 9.25904 10.2055 15.0678 10.1386L371.155 6.04014C374.931 5.99668 377.986 9.07532 377.971 12.8512C377.969 13.2314 377.969 13.5658 377.969 13.8604C377.972 15.3552 377.373 17.0076 377.573 18.489C377.616 18.7991 377.622 19.1154 377.565 19.423C377.506 19.739 377.472 20.0602 377.466 20.383C377.465 20.4446 377.464 20.5106 377.463 20.5721C377.46 20.7568 377.424 20.9454 377.409 21.1299C377.382 21.8254 376.937 22.4069 376.548 22.9841C376.287 23.3718 376.09 23.8085 375.969 24.2747C375.935 24.4045 375.911 24.537 375.867 24.6636L375.383 25.9162C375.227 26.3203 375.336 26.7788 375.657 27.0693C375.832 27.2268 375.943 27.4398 376.005 27.6663C376.181 28.3082 376.53 28.8821 377.01 29.3134C377.22 29.5096 377.448 29.6826 377.689 29.8301C377.712 29.8453 377.719 29.8755 377.705 29.8989L377.696 29.9138C377.364 30.4418 377.168 31.0552 377.127 31.6913C377.104 32.0569 377.132 32.4225 377.21 32.7757C377.324 33.2926 377.445 33.8191 377.6 34.3251C377.714 34.6943 377.875 35.0507 377.897 35.4363C377.91 35.6531 377.905 35.8711 377.883 36.0878C377.882 36.1043 377.882 36.1209 377.882 36.1375C377.877 36.4482 377.785 36.7469 377.668 37.0348C377.505 37.436 377.278 37.8159 376.984 38.1343C376.686 38.4583 376.433 38.8295 376.235 39.2363C376.115 39.4817 376.017 39.7375 375.941 40.0004C375.715 40.7795 375.464 41.5682 375.243 42.3487L375.17 42.5323C375.017 42.913 374.863 43.2981 374.698 43.6788C374.691 43.695 374.687 43.7124 374.687 43.73C374.687 43.7501 374.682 43.7698 374.673 43.7878C374.421 44.2997 374.266 44.8609 374.218 45.4382C374.184 45.8351 374.202 46.234 374.269 46.6238C374.332 46.9863 374.311 47.3606 374.204 47.7123C374.184 47.7772 374.165 47.8426 374.148 47.9084C374.107 48.0621 374.031 48.2028 373.93 48.3253C373.756 48.5355 373.514 48.6903 373.242 48.7085L372.875 48.7331C371.858 48.8013 371.179 49.8101 371.497 50.7782L372.033 52.4051C372.087 52.5687 372.142 52.7235 372.196 52.8783C372.239 52.9941 372.231 53.1219 372.179 53.2338C372.128 53.3436 372.081 53.455 372.037 53.568C371.944 53.8038 371.796 54.0134 371.619 54.1941C371.409 54.4077 371.227 54.6515 371.077 54.9189C370.657 55.6908 370.238 56.4582 369.819 57.2344L369.704 57.4542C369.633 57.5915 369.505 57.6906 369.354 57.7254C369.151 57.7721 368.994 57.9342 368.954 58.1389L368.778 59.041C368.756 59.1529 368.717 59.2607 368.662 59.3606L368.304 60.0149C368.242 60.128 368.274 60.2696 368.378 60.3457C368.458 60.4045 368.497 60.5044 368.478 60.6022C368.396 61.0302 368.311 61.4696 368.218 61.902C368.099 62.4631 367.96 63.0239 367.82 63.5803C367.432 64.999 367.151 66.4494 366.982 67.917C366.938 68.3869 366.865 68.874 366.791 69.3918C366.623 70.3824 366.524 71.385 366.495 72.3912C366.519 72.9221 366.445 73.453 366.279 73.9537L365.514 76.0544C365.464 76.1929 365.519 76.3477 365.646 76.423L366.528 76.9469C366.557 76.9647 366.544 77.0104 366.51 77.0099C366.49 77.0096 366.475 77.0256 366.475 77.0449L366.593 80.3013C366.588 80.6047 366.62 80.8999 366.636 81.1816C366.663 81.7363 366.692 82.2558 366.676 82.7173C366.671 83.0471 366.666 83.3726 366.66 83.7024C366.694 84.2163 366.657 84.733 366.55 85.2357C366.29 86.107 366.348 87.0521 366.712 87.8773L366.739 87.9437C366.845 88.2441 366.946 88.5485 366.98 88.8652C367.003 89.0802 367.026 89.2952 367.048 89.5101C367.087 89.8846 367.115 90.149 367.151 90.4662C367.221 91.0927 367.124 91.7279 367.044 92.3532C367.022 92.528 367.013 92.7048 367.019 92.8817C367.028 93.1794 367.008 93.479 366.947 93.7706C366.821 94.4579 366.624 95.145 366.435 95.8176C366.433 95.8231 366.432 95.8286 366.43 95.834C366.299 96.2633 366.251 96.7173 366.291 97.167C366.314 97.4228 366.364 97.674 366.441 97.9156C366.554 98.2702 366.635 98.6503 366.502 98.9977C366.09 100.21 365.743 101.447 365.461 102.702C365.361 103.118 365.261 103.53 365.153 103.942C365.001 104.529 364.857 105.116 364.718 105.694C364.526 106.529 364.138 107.303 363.763 108.073C363.352 108.917 363.065 109.828 362.914 110.772C362.835 111.145 362.76 111.496 362.674 111.784C362.341 112.892 361.355 113.702 360.855 114.745C360.629 115.215 360.488 115.79 360.418 116.481C360.396 116.659 360.365 116.834 360.324 117.008C360.271 117.253 360.218 117.498 360.182 117.749L360.136 118.025C359.982 118.834 359.899 119.655 359.887 120.479C359.879 121.009 359.878 121.545 359.738 122.056C359.623 122.523 359.532 122.995 359.467 123.473C359.41 124.05 359.421 124.632 359.497 125.205C359.504 125.256 359.506 125.307 359.507 125.358C359.508 125.406 359.512 125.453 359.525 125.5C359.529 125.516 359.532 125.532 359.532 125.548C359.532 125.558 359.531 125.568 359.528 125.577C359.443 125.949 359.327 126.312 359.18 126.661C358.966 127.055 358.803 127.474 358.694 127.909C358.377 129.17 358.199 130.504 357.506 131.605L356.958 132.476C356.894 132.586 356.82 132.69 356.739 132.789C356.113 133.558 355.696 134.337 355.482 135.155C354.988 137.043 355.088 139.097 355.125 141.049C355.13 141.314 355.145 141.578 355.172 141.843C355.195 142.19 355.226 142.543 355.253 142.899C355.352 144.008 355.436 144.986 355.29 145.834C355.255 146.037 355.211 146.239 355.148 146.434C354.83 147.152 354.712 147.954 354.807 148.743C354.902 149.531 355.206 150.272 355.683 150.876C355.787 151.014 355.901 151.263 355.938 152.042C356.003 152.998 356.124 153.949 356.299 154.889C356.572 156.021 356.624 157.202 356.451 158.357C356.069 160.41 355.754 162.503 355.453 164.526C355.344 165.254 355.234 165.983 355.122 166.72C355.085 166.959 355.017 167.191 354.941 167.42C354.884 167.593 354.822 167.766 354.744 167.931C353.796 169.946 352.984 172.033 352.315 174.174L352.213 174.476C352.022 175.076 351.876 175.691 351.776 176.316C351.727 176.575 351.678 176.838 351.617 177.092C351.531 177.425 351.452 177.758 351.373 178.091C351.173 179.008 350.921 179.91 350.618 180.793C350.376 181.374 350.086 181.93 349.753 182.455C349.59 182.738 349.422 183.017 349.267 183.305C349.112 183.593 348.957 183.841 348.798 184.107C348.543 184.543 348.284 184.978 348.028 185.462C346.877 187.683 346.437 190.02 346.133 192.21C346.036 193.049 346.002 193.894 346.031 194.738C346.026 195.059 346.021 195.38 346.016 195.701L346.008 196.18C346.041 196.946 345.958 197.713 345.76 198.45C345.728 198.533 345.661 198.726 345.592 198.97C345.585 198.993 345.563 199.01 345.538 199.01C345.526 199.009 345.514 199.005 345.505 198.998L344.386 198.101C343.764 197.603 342.837 197.851 342.547 198.593C342.33 199.145 341.738 199.452 341.162 199.309L340.759 199.21C339.533 198.906 338.432 200.032 338.764 201.251L339.294 203.198C339.375 203.469 339.419 203.751 339.423 204.036C339.421 204.115 339.383 204.194 339.366 204.273C339.314 204.465 339.266 204.663 339.226 204.86C339.198 205.001 339.17 205.143 339.143 205.285C339.007 205.98 338.738 206.642 338.35 207.234C338.002 207.679 337.78 208.222 337.71 208.799C337.681 209.067 337.665 209.339 337.652 209.611C337.65 209.761 337.647 209.959 337.621 210.051C337.279 211.137 337.085 212.27 337.046 213.415C337.026 213.669 336.937 213.91 336.813 214.132C336.499 214.698 336.3 215.331 336.232 215.989C336.231 216.044 336.225 216.1 336.214 216.154C336.208 216.183 336.202 216.213 336.195 216.242C336.104 216.651 335.823 216.979 335.527 217.275C335.219 217.583 334.96 217.946 334.763 218.349C334.627 218.627 334.523 218.92 334.451 219.222C334.29 219.899 334.006 220.558 333.633 221.146C333.43 221.485 333.265 221.848 333.142 222.227C332.973 222.751 332.554 223.184 332.007 223.252C331.205 223.353 330.722 224.191 331.036 224.935L331.296 225.55C331.481 225.989 331.458 226.481 331.347 226.944C331.326 227.03 331.308 227.118 331.293 227.206C331.237 227.524 331.159 227.84 331.025 228.134C330.847 228.522 330.69 228.92 330.552 229.326C330.309 230.046 329.949 230.724 329.627 231.412C329.383 231.932 329.227 232.498 329.169 233.084C329.165 233.12 329.15 233.154 329.125 233.181C328.514 233.847 328.115 234.706 327.987 235.633C327.986 235.634 327.983 235.674 327.983 235.675C327.983 235.676 327.983 235.676 327.983 235.677C327.803 236.017 327.671 236.34 327.561 236.611C327.537 236.682 327.498 236.747 327.459 236.812C327.344 237.003 327.25 237.208 327.178 237.422C327.116 237.608 327.013 237.778 326.875 237.916C326.675 238.117 326.496 238.34 326.341 238.582C326.212 238.782 325.923 238.825 325.762 238.649C325.585 238.455 325.264 238.53 325.19 238.782L324.04 242.708C323.919 243.146 323.791 243.527 323.667 243.925C323.333 244.914 323.057 245.925 322.841 246.951C322.628 248.052 322.509 249.145 322.382 250.168C322.316 250.752 322.25 251.34 322.167 251.924C322.046 252.852 321.877 253.773 321.663 254.682C321.51 255.311 321.482 255.963 321.58 256.596C321.668 257.17 321.611 257.774 321.283 258.253L320.073 260.017C320.066 260.027 320.07 260.041 320.081 260.046C320.096 260.053 320.096 260.074 320.081 260.081L319.893 260.167C319.834 260.194 319.809 260.265 319.839 260.322L321.246 262.993C321.281 263.06 321.313 263.126 321.34 263.188C321.491 263.524 321.673 263.841 321.885 264.135C321.909 264.169 321.926 264.201 321.914 264.241C321.91 264.258 321.898 264.283 321.894 264.3C321.622 265.312 321.451 266.349 321.381 267.395C321.296 268.669 321.1 269.944 321.015 271.218C320.991 271.581 320.991 271.946 321.015 272.31C321.025 272.45 321.028 272.591 321.026 272.732C321.021 273.011 320.967 273.285 320.898 273.555C320.771 274.05 320.714 274.561 320.728 275.072L320.74 275.525C320.873 280.391 317.006 284.429 312.139 284.507L11.2469 289.326C5.18929 289.423 0.253503 284.488 0.350245 278.43L4.4664 20.6929Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_624_1167)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.32812,
    y: 16.3857,
    width: 446,
    height: 257.437,
    rx: 10.7262,
    transform: "rotate(0.914957 4.32812 16.3857)",
    fill: "#F4B400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.881 -33.3299L2.38281 -36.2285L-0.410688 138.689L181.087 141.588L183.881 -33.3299Z",
    fill: "#F4B400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.38281 -36.2285L-0.410688 138.689",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.625 11.4775L183.114 14.376",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.36719 27.377L182.857 30.2754",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.11719 43.2764L182.607 46.1748",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.863281 59.1758L182.353 62.0742",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8789 -35.9648L16.0854 138.953",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3789 -35.7012L32.5854 139.217",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8711 -35.4385L49.0776 139.479",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3789 -35.1748L65.5854 139.743",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8789 -34.9111L82.0854 140.007",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 -34.6475L98.5815 140.27",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.871 -34.3838L115.078 140.534",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.367 -34.1211L131.574 140.797",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.875 -33.8574L148.081 141.06",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.371 -33.5938L164.578 141.324",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.867 -33.3301L181.074 141.588",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.605469 75.083L182.095 77.9815",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.355469 90.9824L181.845 93.8809",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0976562 106.883L181.587 109.781",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.152344 122.781L181.337 125.68",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.410156 138.688L181.079 141.587",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.365 -30.4315L183.867 -33.3301L181.074 141.588L362.572 144.486L365.365 -30.4315Z",
    fill: "#F4B400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.867 -33.3301L181.074 141.588",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.109 14.375L364.607 17.2736",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.852 30.2754L364.35 33.174",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.602 46.1748L364.1 49.0734",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.348 62.0742L363.846 64.9728",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.367 -33.0664L197.574 141.851",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.879 -32.8027L214.085 142.115",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.371 -32.5391L230.578 142.379",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.871 -32.2764L247.078 142.641",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.367 -32.0127L263.574 142.905",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.875 -31.749L280.081 143.169",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.371 -31.4854L296.578 143.432",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.867 -31.2217L313.074 143.696",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.367 -30.959L329.574 143.959",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.871 -30.6953L346.078 144.222",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.367 -30.4316L362.574 144.486",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.09 77.9814L363.588 80.88",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.84 93.8809L363.338 96.7794",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.582 109.781L363.08 112.68",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.332 125.68L362.83 128.578",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.074 141.587L362.572 144.486",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.088 141.587L-0.410156 138.688L-3.20366 313.606L178.294 316.505L181.088 141.587Z",
    fill: "#F4B400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.664062 154.588L180.825 157.486",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.914062 170.487L180.575 173.386",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.410156 138.688L181.079 141.587",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.17188 186.388L180.317 189.286",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.42188 202.296L180.067 205.194",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.67969 218.193L179.81 221.092",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.92969 234.094L179.56 236.992",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0859 138.951L13.2926 313.861",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5859 139.215L29.7926 314.124",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.082 139.479L46.2887 314.388",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5859 139.742L62.7926 314.652",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0859 140.006L79.2926 314.915",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.582 140.269L95.7887 315.178",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.082 140.532L112.289 315.442",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.574 140.796L128.781 315.705",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.082 141.06L145.289 315.969",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.582 141.323L161.789 316.233",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.074 141.587L178.281 316.496",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.1875 249.992L179.302 252.891",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.44141 265.9L179.048 268.799",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.69141 281.799L178.798 284.697",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.38076 -36.2284L-179.117 -39.127L-181.911 135.791L-0.412743 138.689L2.38076 -36.2284Z",
    fill: "#F4B400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-179.875 8.57812L1.62295 11.4767",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-180.133 24.4785L1.36514 27.3771",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-180.383 40.3779L1.11514 43.2765",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-180.641 56.2764L0.857326 59.175",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.38281 -36.2285L-0.410688 138.689",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-180.895 72.1836L0.60342 75.0822",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-181.145 88.084L0.35342 90.9826",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.572 144.486L181.074 141.587L178.281 316.505L359.779 319.403L362.572 144.486Z",
    fill: "#F4B400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.074 141.587L178.281 316.496",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.82 157.486L362.318 160.385",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.57 173.386L362.068 176.284",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.074 141.587L362.572 144.486",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.312 189.286L361.81 192.185",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.062 205.194L361.56 208.093",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.805 221.092L361.303 223.99",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.555 236.992L361.053 239.891",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.574 141.85L194.781 316.759",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.086 142.113L211.293 317.023",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.582 142.377L227.789 317.286",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.078 142.641L244.285 317.55",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.574 142.904L260.781 317.814",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.082 143.168L277.289 318.077",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.582 143.431L293.789 318.34",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.074 143.694L310.281 318.604",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.574 143.958L326.781 318.867",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.078 144.222L343.285 319.131",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.578 144.485L359.785 319.395",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.301 252.891L360.799 255.789",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.043 268.799L360.541 271.697",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.793 284.697L360.291 287.596",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.865 -27.5331L365.367 -30.4316L362.574 144.486L544.072 147.385L546.865 -27.5331Z",
    fill: "#F4B400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.367 -30.4316L362.574 144.486",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.609 17.2744L546.107 20.173",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.355 33.1738L545.853 36.0724",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.102 49.0732L545.6 51.9718",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.848 64.9727L545.346 67.8712",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.59 80.8799L545.088 83.7785",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.34 96.7793L544.838 99.6779",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.086 112.68L544.584 115.578",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.832 128.578L544.33 131.477",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.578 144.485L544.076 147.384",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.076 147.384L362.578 144.485L359.785 319.403L541.283 322.302L544.076 147.384Z",
    fill: "#F4B400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.578 144.485L359.785 319.395",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.32 160.385L543.818 163.283",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.07 176.284L543.568 179.183",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.578 144.485L544.076 147.384",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.812 192.185L543.31 195.083",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.562 208.093L543.06 210.991",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.309 223.991L542.807 226.89",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.055 239.891L542.553 242.789",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.07 144.749L376.277 319.658",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.801 255.789L542.299 258.688",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.543 271.697L542.041 274.596",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.293 287.597L541.791 290.495",
    stroke: "white",
    strokeWidth: 0.663374,
    strokeMiterlimit: 10
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.3eb6d6aacd2e0a323c3b222ca10e3701.svg";
export { ForwardRef as ReactComponent };